import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Row, Col, Card, Button } from "react-bootstrap";
import Constants from "../../../common/Constants";
import { useTranslation } from "react-i18next";
// import { fetchMasterList } from "../../../redux/feature/manufacturing_app/commonMasterListSlice";
import { Link, useNavigate } from "react-router-dom";
import { toastFunc } from "../../../components/common/util";
// import config from "../../../services/configuration";
import ItemService from "../../../services/commonService";
import {
  fetchActiveMasterListById,
  addMasterRecord,
} from "../../../redux/feature/manufacturing_app/commonMasterListSlice";
import moment from "moment";
import Loader from "../../../common/Loader";
import OverviewMachinesModal from "./OverviewMachinesModal";
import {
  getCurrentDate,
  formatDate,
  applyMathAndFormat,
  currencyFormat,
} from "../../../common/Validations";
import DatePicker from "react-widgets/DatePicker";
import OverviewTableModal from "./OverviewTableModal";
import DeptTargetForm from "./master/DeptTargetForm";

// const baseURL = config.BASE_URL;

const Overview = () => {
  const dispatch = useDispatch();

  const [rowsData, setRowsData] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [dbChangeData, setDbChangeData] = useState([]);
  const [machinesData, setMachinesData] = useState([]);

  const [loaderStatus, setLoaderStatus] = useState(false);
  const [monthlyLoaderStatus, setMonthlyLoaderStatus] = useState(false);

  const [openAllMachineDetails, setOpenAllMachineDetails] = useState(false);
  const [openDataTable, setOpenDataTable] = useState(false);
  const [openDataTableData, setOpenDataTableData] = useState([]);

  const [requiredFrom, setRequiredFrom] = useState(new Date());

  const [openTargetTable, setOpenTargetTable] = useState(false);
  const [targetData, setTargetData] = useState({});

  const [montlyData, setMonthlyData] = useState({});
  const [showMonthlyHeader, setShowMonthlyHeader] = useState(false);

  // ✅ NEW: Per-card, per-section toggles
  // structure: { [cardKey]: { pending: bool, completed: bool, running: bool } }
  const [cardToggles, setCardToggles] = useState({});

  const getCardKey = (val, index) => val?.deptCode || val?._id || String(index);
  const isOpen = (cardKey, section) => !!cardToggles?.[cardKey]?.[section];

  // If you want multiple sections open inside same card, use this
  const toggleSection = (cardKey, section) => {
    setCardToggles((prev) => ({
      ...prev,
      [cardKey]: {
        ...(prev[cardKey] || {}),
        [section]: !prev?.[cardKey]?.[section],
      },
    }));
  };

  // If you want only ONE section open at a time inside same card, use this instead:
  // const toggleSectionOnlyOne = (cardKey, section) => {
  //   setCardToggles((prev) => {
  //     const current = prev[cardKey] || {};
  //     const nextValue = !current?.[section];
  //     return {
  //       ...prev,
  //       [cardKey]: { pending: false, completed: false, running: false, [section]: nextValue },
  //     };
  //   });
  // };

  const fetchDeptBySockets = async () => {
    let obj = { currentDate: getCurrentDate() };

    const item = await ItemService.getOverview(obj);

    if (item?.status === 200) {
      setRowsData(item?.data);
    }

    setLoaderStatus(false);
  };

  const fetchMonthOverview = async () => {
    let obj = {
      startDate: formatDate(
        new Date(requiredFrom.getFullYear(), requiredFrom.getMonth(), 1)
      ),
      endDate: formatDate(
        new Date(requiredFrom.getFullYear(), requiredFrom.getMonth() + 1, 0)
      ),
    };

    const item = await ItemService.getMonthOverview(obj);

    if (item?.status === 200) {
      setMonthlyData(item?.data);
    }

    setMonthlyLoaderStatus(false);
  };

  useEffect(() => {
    setLoaderStatus(true);
    setMonthlyLoaderStatus(true);

    Promise.allSettled([fetchDeptBySockets(), fetchMonthOverview()]).then(() => {
      setLoaderStatus(false);
      setMonthlyLoaderStatus(false);
    });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    let param = {};
    param.url = "getActiveMasterListDataById";
    param.page = Constants.MASTER.MACHINES.name;

    dispatch(fetchActiveMasterListById(param)).then((result) => {
      setMachinesData(result?.payload?.data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowsData]);

  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleMachines = (event, deptCode) => {
    event.preventDefault();
    navigate(Constants.OVERVIEWMACHINES, { state: { deptCode: deptCode } });
  };

  const openAllMachineData = () => {
    setOpenAllMachineDetails(true);
  };

  const openAllTableData = (data) => {
    setOpenDataTable(true);
    setOpenDataTableData(data);
  };

  const setOpenTargetTableData = (data) => {
    setOpenTargetTable(true);
    setTargetData(data);
  };

  const clearOpenTargetTableData = () => {
    setOpenTargetTable(false);
    setTargetData({});
  };

  const saveTarget = (data) => {
    const param = { ...data };
    param.method = Constants.MASTER.DEPARTMENT.TARGET;
    dispatch(addMasterRecord(param)).then((res) => {
      if (res?.payload?.status === 200) {
        fetchDeptBySockets()
        toastFunc(
          Constants.MASTER.TOAST.success,
          t("msg_master_list.msg_department.success_target"),
          2000
        );
        clearOpenTargetTableData();
      }
    });
  };

  const handleSearch = async () => {
    setMonthlyData({});
    setLoaderStatus(true);
    setMonthlyLoaderStatus(true);

    fetchMonthOverview();

    let obj = {
      currentDate: moment(requiredFrom).format("DD-MM-YYYY"),
    };

    await ItemService.getOverview(obj).then((item) => {
      if (item?.status === 200) {
        setRowsData(item?.data);
      }
      setLoaderStatus(false);
    });
  };

  return (
    <main className="dashboard main" id="main">
      <Row className="justify-center subContent">
        <Col xs={4} md={2}>
          <h2 className="mainTitle">{"Overview"} </h2>
          <p className="subText">{""}</p>
        </Col>

        <Col xs={8} md={10} className="leftSide d-flex align-items-center">
          <DatePicker
            required
            max={new Date()}
            placeholder="Date"
            name="requiredFrom"
            valueFormat={{ dateStyle: "medium" }}
            value={requiredFrom}
            onChange={(date) => {
              setRequiredFrom(date);
            }}
            autoFocus
            popperPlacement="auto-end"
          />
          <Button
            type="button"
            variant="primary"
            className="btn btn-primary ml-2"
            onClick={handleSearch}
          >
            Go
          </Button>
        </Col>
        <hr />
      </Row>

      <Row>
        <Col lg={9} md={9} sm={9} className="border-right-column">
          <Loader
            isLoading={loaderStatus || monthlyLoaderStatus}
            className={"text-center"}
          />

          {/* ✅ Monthly header section (global) */}
          <div className="monthly-overview-wrapper">
            <div
              className="monthly-overview-header"
              onClick={() => setShowMonthlyHeader((prev) => !prev)}
            >
              <strong>{"Monthly Overview"}</strong>
              <span
                className={
                  showMonthlyHeader ? "toggle-arrow open" : "toggle-arrow"
                }
              >
                <i className="bi bi-caret-down-fill"></i>
              </span>
            </div>

            <div
              className={
                showMonthlyHeader ? "monthly-content show" : "monthly-content"
              }
            >
              <Row className="monthly-container">
                <Col lg={4} sm={4} className="monthly-column">
                  <div className="block">
                    <div className="block-header urgent-color">
                      {t("msg_overview.urgent")}
                    </div>

                    <div className="block-item">
                      <label>{t("msg_overview.monthlyCompleted")}</label>
                      <span>
                        {currencyFormat(montlyData.completedMonthlyCountUrgent)}
                      </span>
                    </div>

                    <div className="block-item">
                      <label>{t("msg_overview.cuttingBody")}</label>
                      <span>{currencyFormat(montlyData.urgentMonthlyCBCount)}</span>
                    </div>

                    <div className="block-item">
                      <label>{t("msg_overview.roundBody")}</label>
                      <span>{currencyFormat(montlyData.urgentMonthlyRBCount)}</span>
                    </div>

                    <div className="block-item">
                      <label>{t("msg_overview.totalQuantity")}</label>
                      <span>{currencyFormat(montlyData.urgentMonthlyTotalQty)}</span>
                    </div>

                    <div className="block-item">
                      <label>{t("msg_overview.totalQuantityDozen")}</label>
                      <span>{currencyFormat(montlyData.urgentMonthlyQtyInDozen)}</span>
                    </div>
                  </div>
                </Col>

                <Col lg={4} sm={4} className="monthly-column">
                  <div className="block">
                    <div className="block-header regular-color">
                      {t("msg_overview.regular")}
                    </div>

                    <div className="block-item">
                      <label>{t("msg_overview.monthlyCompleted")}</label>
                      <span>
                        {currencyFormat(montlyData.completedMonthlyCountRegular)}
                      </span>
                    </div>

                    <div className="block-item">
                      <label>{t("msg_overview.cuttingBody")}</label>
                      <span>{currencyFormat(montlyData.regularMonthlyCBCount)}</span>
                    </div>

                    <div className="block-item">
                      <label>{t("msg_overview.roundBody")}</label>
                      <span>{currencyFormat(montlyData.regularMonthlyRBCount)}</span>
                    </div>

                    <div className="block-item">
                      <label>Total Quantity</label>
                      <span>{currencyFormat(montlyData.regularMonthlyTotalQty)}</span>
                    </div>

                    <div className="block-item">
                      <label>{t("msg_overview.totalQuantityDozen")}</label>
                      <span>{currencyFormat(montlyData.regularMonthlyQtyInDozen)}</span>
                    </div>
                  </div>
                </Col>

                <Col lg={4} sm={4} className="monthly-column">
                  <div className="block">
                    <div className="block-header regular-color">
                      {t("msg_overview.total")}
                    </div>

                    <div className="block-item">
                      <label>{t("msg_overview.monthlyCompleted")}</label>
                      <span>
                        {currencyFormat(
                          Number(montlyData.completedMonthlyCountRegular) +
                            Number(montlyData.completedMonthlyCountUrgent)
                        )}
                      </span>
                    </div>

                    <div className="block-item">
                      <label>{t("msg_overview.cuttingBody")}</label>
                      <span>
                        {currencyFormat(
                          Number(montlyData.regularMonthlyCBCount) +
                            Number(montlyData.urgentMonthlyCBCount)
                        )}
                      </span>
                    </div>

                    <div className="block-item">
                      <label>{t("msg_overview.roundBody")}</label>
                      <span>
                        {currencyFormat(
                          Number(montlyData.regularMonthlyRBCount) +
                            Number(montlyData.urgentMonthlyRBCount)
                        )}
                      </span>
                    </div>

                    <div className="block-item">
                      <label>Total Quantity</label>
                      <span>
                        {currencyFormat(
                          Number(montlyData.regularMonthlyTotalQty) +
                            Number(montlyData.urgentMonthlyTotalQty)
                        )}
                      </span>
                    </div>

                    <div className="block-item">
                      <label>{t("msg_overview.totalQuantityDozen")}</label>
                      <span>
                        {currencyFormat(
                          Number(montlyData.regularMonthlyQtyInDozen) +
                            Number(montlyData.urgentMonthlyQtyInDozen)
                        )}
                      </span>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>

          <hr />

          <Row>
            {rowsData?.map((val, index) => {
              const cardKey = getCardKey(val, index);

              return (
                <Col key={cardKey} lg={4} md={4} sm={6}>
                  <Card border="primary" className="overview-card">
                    <Card.Header
                      as="h5"
                      title={`${val.deptCode} - ${val.deptName}`}
                    >
                      {val.deptCode}: {val.deptName}
                      <span
                        className="overview-card-header-value"
                        title="Set Target"
                      >
                        <i
                          className="bi bi-receipt-cutoff"
                          onClick={() => setOpenTargetTableData(val)}
                        ></i>
                      </span>
                    </Card.Header>

                    <Card.Body>
                      <Row className="card-body-row">
                        <Col lg={6} md={6} sm={6}>
                          <div className="dates overview-padding-left">
                            {"Target Qty"} :{" "}
                            {val.targetTotalQty}
                          </div>
                        </Col>
                        <Col lg={6} md={6} sm={6}>
                          <div className="dates overview-padding-left">
                            {"Target QtyDZ"} :{" "}
                            {val.targetQtyInDozen}
                          </div>
                        </Col>
                      </Row>

                      <Row className="card-body-row">
                        <Col lg={12} md={12} sm={12}>
                          <div className="dates">
                            <strong className="column-card-heading">
                              Acknowledgement Pending
                            </strong>

                            <div
                              className="urgent"
                              onClick={() =>
                                openAllTableData(
                                  val.acknowledgementPendingUrgentList,
                                )
                              }
                            >
                              {currencyFormat(
                                val.acknowledgementPendingCountUrgent || 0,
                              )}
                              <strong>{t("msg_overview.urgent")}</strong>
                              <span></span>
                            </div>

                            <div
                              className="regular"
                              onClick={() =>
                                openAllTableData(
                                  val.acknowledgementPendingRegularList,
                                )
                              }
                            >
                              {currencyFormat(
                                val.acknowledgementPendingCountRegular || 0,
                              )}
                              <strong>{t("msg_overview.regular")}</strong>
                            </div>
                          </div>
                        </Col>
                      </Row>

                      <Row className="card-body-row">
                        <Col lg={6} md={6} sm={6}>
                          <div className="dates">
                            <strong className="column-card-heading">
                              {t("msg_overview.pending")} TILL NOW
                            </strong>

                            <div
                              className="urgent"
                              onClick={() => openAllTableData(val.pendingUrgentList)}
                            >
                              {val.pendingCountUrgent}
                              <strong>{t("msg_overview.urgent")}</strong>
                              <span></span>
                            </div>

                            <div
                              className="regular"
                              onClick={() => openAllTableData(val.pendingRegularList)}
                            >
                              {val.pendingCountRegular}
                              <strong>{t("msg_overview.regular")}</strong>
                            </div>
                          </div>
                        </Col>

                        <Col lg={6} md={6} sm={6}>
                          <div className="dates">
                            <strong className="column-card-heading">
                              {t("msg_overview.completed")}
                            </strong>

                            <div
                              className="urgent"
                              onClick={() => openAllTableData(val.completedUrgentList)}
                            >
                              {val.completedCountUrgent}
                              <strong>{t("msg_overview.urgent")}</strong>
                              <span></span>
                            </div>

                            <div
                              className="regular"
                              onClick={() =>
                                openAllTableData(val.completedRegularList)
                              }
                            >
                              {val.completedCountRegular}
                              <strong>{t("msg_overview.regular")}</strong>
                            </div>
                          </div>
                        </Col>
                      </Row>

                      {/* ✅ Pending toggle (per-card) */}
                      <div className="monthly-overview-wrapper">
                        <div
                          className="monthly-overview-header fs-6 fw-normal"
                          onClick={() => toggleSection(cardKey, "pending")}
                        >
                          <strong>{"Pending"}</strong>
                          <span
                            className={
                              isOpen(cardKey, "pending")
                                ? "toggle-arrow open"
                                : "toggle-arrow"
                            }
                          >
                            <i className="bi bi-caret-down-fill"></i>
                          </span>
                        </div>

                        <div
                          className={
                            isOpen(cardKey, "pending") ? "show" : "monthly-content"
                          }
                        >
                          <Card className="overview-card mb-2">
                            <Row>
                              <strong className="column-card-heading">
                                {"Pending"}
                              </strong>

                              <Col lg={6} md={6} sm={12} className="left-section">
                                <strong className="column-card-heading">
                                  {t("msg_overview.urgent")}
                                </strong>

                                <div className="detail-row">
                                  <span>{t("msg_overview.urgentRBCount")}:</span>
                                  <span className="fw-bold">
                                    {currencyFormat(val.urgentPendingRBCount)}
                                  </span>
                                </div>

                                <div className="detail-row">
                                  <span>{t("msg_overview.urgentCBCount")}:</span>
                                  <span className="fw-bold">
                                    {currencyFormat(val.urgentPendingCBCount)}
                                  </span>
                                </div>

                                <div className="detail-row">
                                  <span>
                                    {t("msg_overview.urgentTotalQuantity")}:
                                  </span>
                                  <span className="fw-bold">
                                    {currencyFormat(val.urgentPendingTotalQty)}
                                  </span>
                                </div>

                                <div className="detail-row">
                                  <span>
                                    {t("msg_overview.urgentTotalQuanityDozen")}:
                                  </span>
                                  <span className="fw-bold">
                                    {currencyFormat(
                                      applyMathAndFormat(
                                        val.urgentPendingTotalQty / 12,
                                        "round"
                                      )
                                    )}
                                  </span>
                                </div>
                              </Col>

                              <Col lg={6} md={6} sm={12} className="right-section">
                                <strong className="column-card-heading">
                                  {t("msg_overview.regular")}
                                </strong>

                                <div className="detail-row">
                                  <span>{t("msg_overview.regularRBCount")}:</span>
                                  <span className="fw-bold">
                                    {currencyFormat(val.regularPendingRBCount)}
                                  </span>
                                </div>

                                <div className="detail-row">
                                  <span>{t("msg_overview.regularCBCount")}:</span>
                                  <span className="fw-bold">
                                    {currencyFormat(val.regularPendingCBCount)}
                                  </span>
                                </div>

                                <div className="detail-row">
                                  <span>
                                    {t("msg_overview.regularTotalQuantity")}:
                                  </span>
                                  <span className="fw-bold">
                                    {currencyFormat(val.regularTotalPendingQty)}
                                  </span>
                                </div>

                                <div className="detail-row">
                                  <span>
                                    {t("msg_overview.regularTotalQuanityDozen")}:
                                  </span>
                                  <span className="fw-bold">
                                    {currencyFormat(
                                      applyMathAndFormat(
                                        val.regularTotalPendingQty / 12,
                                        "round"
                                      )
                                    )}
                                  </span>
                                </div>
                              </Col>
                            </Row>
                          </Card>
                        </div>
                      </div>

                      {/* ✅ Completed toggle (per-card) */}
                      <div className="monthly-overview-wrapper">
                        <div
                          className="monthly-overview-header fs-6 fw-normal"
                          onClick={() => toggleSection(cardKey, "completed")}
                        >
                          <strong>{"Completed"}</strong>
                          <span
                            className={
                              isOpen(cardKey, "completed")
                                ? "toggle-arrow open"
                                : "toggle-arrow"
                            }
                          >
                            <i className="bi bi-caret-down-fill"></i>
                          </span>
                        </div>

                        <div
                          className={
                            isOpen(cardKey, "completed")
                              ? "show"
                              : "monthly-content"
                          }
                        >
                          <Card className="overview-card mb-2">
                            <Row>
                              <strong className="column-card-heading">
                                {"Completed"}
                              </strong>

                              <Col lg={6} md={6} sm={12} className="left-section">
                                <strong className="column-card-heading">
                                  {t("msg_overview.urgent")}
                                </strong>

                                <div className="detail-row">
                                  <span>{t("msg_overview.urgentRBCount")}:</span>
                                  <span className="fw-bold">
                                    {currencyFormat(val.urgentCompletedRBCount)}
                                  </span>
                                </div>

                                <div className="detail-row">
                                  <span>{t("msg_overview.urgentCBCount")}:</span>
                                  <span className="fw-bold">
                                    {currencyFormat(val.urgentCompletedCBCount)}
                                  </span>
                                </div>

                                <div className="detail-row">
                                  <span>
                                    {t("msg_overview.urgentTotalQuantity")}:
                                  </span>
                                  <span className="fw-bold">
                                    {currencyFormat(val.urgentCompletedTotalQty)}
                                  </span>
                                </div>

                                <div className="detail-row">
                                  <span>
                                    {t("msg_overview.urgentTotalQuanityDozen")}:
                                  </span>
                                  <span className="fw-bold">
                                    {currencyFormat(
                                      applyMathAndFormat(
                                        val.urgentCompletedTotalQty / 12,
                                        "round"
                                      )
                                    )}
                                  </span>
                                </div>
                              </Col>

                              <Col lg={6} md={6} sm={12} className="right-section">
                                <strong className="column-card-heading">
                                  {t("msg_overview.regular")}
                                </strong>

                                <div className="detail-row">
                                  <span>{t("msg_overview.regularRBCount")}:</span>
                                  <span className="fw-bold">
                                    {currencyFormat(val.regularCompletedRBCount)}
                                  </span>
                                </div>

                                <div className="detail-row">
                                  <span>{t("msg_overview.regularCBCount")}:</span>
                                  <span className="fw-bold">
                                    {currencyFormat(val.regularCompletedCBCount)}
                                  </span>
                                </div>

                                <div className="detail-row">
                                  <span>
                                    {t("msg_overview.regularTotalQuantity")}:
                                  </span>
                                  <span className="fw-bold">
                                    {currencyFormat(val.regularTotalCompletedQty)}
                                  </span>
                                </div>

                                <div className="detail-row">
                                  <span>
                                    {t("msg_overview.regularTotalQuanityDozen")}:
                                  </span>
                                  <span className="fw-bold">
                                    {currencyFormat(
                                      applyMathAndFormat(
                                        val.regularTotalCompletedQty / 12,
                                        "round"
                                      )
                                    )}
                                  </span>
                                </div>
                              </Col>
                            </Row>
                          </Card>
                        </div>
                      </div>

                      {/* ✅ Running Count toggle (per-card) */}
                      <div className="monthly-overview-wrapper">
                        <div
                          className="monthly-overview-header fs-6 fw-normal"
                          onClick={() => toggleSection(cardKey, "running")}
                        >
                          <strong>{"Running Count"}</strong>
                          <span
                            className={
                              isOpen(cardKey, "running")
                                ? "toggle-arrow open"
                                : "toggle-arrow"
                            }
                          >
                            <i className="bi bi-caret-down-fill"></i>
                          </span>
                        </div>

                        <div
                          className={
                            isOpen(cardKey, "running") ? "show" : "monthly-content"
                          }
                        >
                          <Card className="overview-card mb-2">
                            <Row>
                              <strong className="column-card-heading">
                                {"RUNNING COUNT"}
                              </strong>

                              <Col lg={6} md={6} sm={12} className="left-section">
                                <strong className="column-card-heading">
                                  {t("msg_overview.urgent")}
                                </strong>

                                <div className="detail-row">
                                  <span>{t("msg_overview.urgentRBCount")}:</span>
                                  <span className="fw-bold">
                                    {currencyFormat(val.urgentDaysRBCount)}
                                  </span>
                                </div>

                                <div className="detail-row">
                                  <span>{t("msg_overview.urgentCBCount")}:</span>
                                  <span className="fw-bold">
                                    {currencyFormat(val.urgentDaysCBCount)}
                                  </span>
                                </div>

                                <div className="detail-row">
                                  <span>
                                    {t("msg_overview.urgentTotalQuantity")}:
                                  </span>
                                  <span className="fw-bold">
                                    {currencyFormat(val.urgentDaysTotalQty)}
                                  </span>
                                </div>

                                <div className="detail-row">
                                  <span>
                                    {t("msg_overview.urgentTotalQuanityDozen")}:
                                  </span>
                                  <span className="fw-bold">
                                    {currencyFormat(
                                      applyMathAndFormat(
                                        val.urgentDaysTotalQty / 12,
                                        "round"
                                      )
                                    )}
                                  </span>
                                </div>
                              </Col>

                              <Col lg={6} md={6} sm={12} className="right-section">
                                <strong className="column-card-heading">
                                  {t("msg_overview.regular")}
                                </strong>

                                <div className="detail-row">
                                  <span>{t("msg_overview.regularRBCount")}:</span>
                                  <span className="fw-bold">
                                    {currencyFormat(val.regularDaysRBCount)}
                                  </span>
                                </div>

                                <div className="detail-row">
                                  <span>{t("msg_overview.regularCBCount")}:</span>
                                  <span className="fw-bold">
                                    {currencyFormat(val.regularDaysCBCount)}
                                  </span>
                                </div>

                                <div className="detail-row">
                                  <span>
                                    {t("msg_overview.regularTotalQuantity")}:
                                  </span>
                                  <span className="fw-bold">
                                    {currencyFormat(val.regularTotalDaysQty)}
                                  </span>
                                </div>

                                <div className="detail-row">
                                  <span>
                                    {t("msg_overview.regularTotalQuanityDozen")}:
                                  </span>
                                  <span className="fw-bold">
                                    {currencyFormat(
                                      applyMathAndFormat(
                                        val.regularTotalDaysQty / 12,
                                        "round"
                                      )
                                    )}
                                  </span>
                                </div>
                              </Col>
                            </Row>
                          </Card>
                        </div>
                      </div>
                    </Card.Body>

                    <Card.Footer>
                      <Row>
                        <Col
                          lg={12}
                          md={12}
                          sm={12}
                          className="d-flex justify-content-center align-items-center"
                        >
                          <div className="overview-footer">
                            <div className="machines-quantity">
                              <Link
                                href="#"
                                onClick={(e) => handleMachines(e, val.deptCode)}
                              >
                                {"View Machines"}
                              </Link>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Card.Footer>
                  </Card>
                </Col>
              );
            })}
          </Row>
        </Col>

        {/* Right side Machine cards */}
        <Col lg={3} md={3} sm={3} className="position-relative">
          <div className="circle-overlay" onClick={openAllMachineData}>
            <i className="bi bi-card-checklist" title="View All Machines"></i>
          </div>

          <div className="status-col-wrapper">
            <div className="status-col auto-scroll">
              {machinesData?.map((val, index) => (
                <Card
                  text={"white"}
                  key={index}
                  className="card machine-overview-card"
                  cssNamespace="horizontal"
                >
                  <Card.Body>
                    <div className="status-row">
                      <span className="chip chip-blue">
                        <i className="bi bi-diagram-2-fill"></i> &nbsp;
                        {`${val.deptCode} : ${val.deptName}`}
                      </span>
                      <span className="chip chip-blue">
                        <i className="bi bi-tools"></i> &nbsp;{val.machineCode}
                      </span>
                      <span className="chip chip-green">
                        <i className="bi-person-fill"></i> &nbsp;{" "}
                        {val.operatorUserName}
                      </span>
                      <span className="chip chip-blue">
                        <i className="bi bi-reception-3"></i> &nbsp;{val.sizeCode}
                      </span>

                      {val.jobcard ? (
                        <span className="chip chip-blue">
                          <i className="bi bi-suitcase-lg"></i> &nbsp; {val.jobcard}
                        </span>
                      ) : (
                        val.assignedJobCardList?.map((m, i) => (
                          <span key={i} className="chip chip-blue">
                            <i className="bi bi-suitcase-lg"></i> &nbsp; {m}
                          </span>
                        ))
                      )}

                      <span className="chip chip-red">
                        <i className="bi bi-alarm"></i> &nbsp;&nbsp;
                        {val?.updatedDate
                          ? moment(val?.updatedDate).format("DD-MM-YYYY HH:mm:ss")
                          : ""}
                      </span>
                    </div>
                  </Card.Body>
                </Card>
              ))}
            </div>
          </div>
        </Col>
      </Row>

      {openAllMachineDetails && (
        <OverviewMachinesModal
          machineData={machinesData}
          show={openAllMachineDetails}
          onHide={() => setOpenAllMachineDetails(false)}
        />
      )}

      {openDataTable && (
        <OverviewTableModal
          tableData={openDataTableData}
          show={openDataTable}
          onHide={() => setOpenDataTable(false)}
        />
      )}

      {openTargetTable && (
        <DeptTargetForm
          data={targetData}
          month={requiredFrom.getMonth() + 1}
          year={requiredFrom.getFullYear()}
          date={requiredFrom}
          show={openTargetTable}
          onSave={saveTarget}
          onHide={() => clearOpenTargetTableData()}
        />
      )}
    </main>
  );
};

export default Overview;
